import { render, staticRenderFns } from "./create-productcategory.vue?vue&type=template&id=4c6ebcae"
import script from "./create-productcategory.vue?vue&type=script&lang=ts"
export * from "./create-productcategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports